import { useQuery } from '@threatadvisor/react-utils';
import { format } from 'date-fns';
import React, { ReactElement } from 'react';

export default function Legal(): ReactElement {
  const search = useQuery();
  const applyWhiteLabel = search.get('whitelabel') === 'true';

  return (
    <div className="report-section page-break">
      <a id="hCopyright" className="i-link"></a>
      <h3 style={{ marginTop: 0 }} className="text-uppercase">
        Copyright
      </h3>
      <p>
        © {format(new Date(), 'yyyy')} {applyWhiteLabel ? 'ThreatAdvisor' : `DirectDefense Inc.`}{' '}
        All Rights Reserved. This document is unpublished material and contains trade secrets and
        other confidential information that are subject to a confidentiality agreement. The
        unauthorized possession, use, reproduction, distribution, display, or disclosure of this
        material or the information contained herein is prohibited.
      </p>
      <p>
        The methodology used to audit the computer systems is considered proprietary intellectual
        information of {applyWhiteLabel ? 'ThreatAdvisor' : 'DirectDefense'}, and may not be
        disclosed without written permission from
        {applyWhiteLabel ? 'ThreatAdvisor' : 'DirectDefense'}, Inc.{' '}
        {applyWhiteLabel ? 'ThreatAdvisor' : 'DirectDefense'} grants the client organization
        permission to copy this report for the purposes of disseminating information within its
        organization, or to regulatory agencies.
      </p>
      <a id="hConfidentiality" className="i-link"></a>
      <h3 className="text-uppercase">Confidentiality</h3>
      <p>
        This document contains company confidential information of a proprietary and sensitive
        nature. As such this document should be afforded the security and handling precautions that
        a confidential document warrants. This document should have a controlled distribution to
        relevant parties only and should not be copied without written permission.
      </p>
      <p>
        {applyWhiteLabel ? 'ThreatAdvisor' : 'DirectDefense'} treats the contents of a security
        audit as company confidential material and will not disclose the contents of this document
        to anyone without written permission from the client organization.
      </p>
    </div>
  );
}
